import { useLoading } from '@gorila-shared-ui/components';
import { useEffect, useState } from 'react';
import { getS3FileUrlByKey } from '../services/appService';
import { FileDisplay } from '../types/app';

export function useFilesDisplay(fileKeys: string[] = []) {
  const [files, setFiles] = useState<FileDisplay[]>();
  const { loading, startLoading, stopLoading } = useLoading();

  useEffect(() => {
    const loadFilesUrl = async () => {
      if (fileKeys?.length) {
        startLoading();
        const newFiles: FileDisplay[] = [];
        const requests = fileKeys.map((key) => {
          return getS3FileUrlByKey(key).then((result) => ({ ...result, key }));
        });
        const results = await Promise.allSettled(requests);
        results.forEach((result) => {
          if (result.status === 'fulfilled') {
            newFiles.push({
              key: result.value.key,
              url: result.value.url ?? '',
            });
          }
        });
        setFiles(newFiles);
        stopLoading();
      }
    };

    loadFilesUrl();
  }, [fileKeys]);

  return {
    files,
    loading,
  };
}
